module.exports = __webpack_public_path__ + "img/border1.c67d43a3.png";